module.exports = __webpack_public_path__ + "img/ico_link.0cdc5a6a.svg";